import _ from 'underscore';
import { RECOMMENDATION_TYPES, APPLY_ACTION_TYPES } from '@bingads-webui-campaign/recommendation-core';


function isPlural(value) {
  return value > 1 ? 'Plural' : 'Singular';
}

/**
 * Format Notification Localized Key of i18n
 * @param {number} count - count of entity
 * @param {Boolean} isSuccess - result of request to MT
 * @param {String} recommendationType - Recommendation Type
 * @param {String} actionType - Action Type
 * @return {string} formatted string
 */

export const formatNotificationLocalizedKey = ({
  count,
  isSuccess,
  recommendationType,
  actionType,
  otherInfo = {},
}) => {
  let form = isPlural(count);
  const result = isSuccess ? 'Success' : 'Error';
  let entity = '';
  let zeroSucceedScenario = '';
  switch (recommendationType) {
    case RECOMMENDATION_TYPES.REPAIR_ADS:
      entity = 'Ad';
      break;
    case RECOMMENDATION_TYPES.REPAIR_KEYWORD:
      entity = 'Keyword';
      break;
    case RECOMMENDATION_TYPES.FIX_AD_DESTINATION:
      if (actionType === APPLY_ACTION_TYPES.ACCEPT && !_.isEmpty(otherInfo)) {
        entity = 'Fix_Ad_Destination';
        const {
          SuccessAdsCount = 0,
          SuccessKeywordsCount = 0,
          FailedAdsCount = 0,
          FailedKeywordsCount = 0,
        } = otherInfo;
        if (isSuccess) {
          form = `${isPlural(SuccessAdsCount)}_${isPlural(SuccessKeywordsCount)}_${isPlural(SuccessAdsCount + SuccessKeywordsCount)}`;
        } else {
          form = `${isPlural(FailedAdsCount)}_${isPlural(FailedKeywordsCount)}_${isPlural(FailedAdsCount + FailedKeywordsCount)}`;
        }
      } else {
        entity = 'Default';
      }
      break;
    default:
      entity = 'Default';
      if (count === 0) {
        zeroSucceedScenario = '_Zero';
      }
  }
  return `Recommendation_${actionType}_${entity}_${form}_${result}_Message${zeroSucceedScenario}`;
};
